import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, roles = null }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="font-mono-p text-cyan-400 text-sm tracking-[0.3em] animate-pulse">
          AUTHENTICATING...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.super_admin) return children;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
